export const withTransformResponse = (client, transformers) => {
    const { transformResponse } = client.defaults;
    if (transformResponse == null) {
        return transformers;
    }
    return new Array().concat(transformResponse, transformers);
};
export const stringifyParams = (params) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (Array.isArray(v)) {
            v.forEach((v) => searchParams.append(k, v));
        }
        else {
            searchParams.append(k, v);
        }
    });
    const queryString = searchParams
        .toString()
        // URLSearchParams encodes spaces as '+' characters
        // revert to percent encoding for spaces as this is what search service expects
        .replace('+', '%20');
    return queryString;
};
//# sourceMappingURL=utils.js.map